// Strings rendered by the Internal E-Mail-Verwaltung screen: the send robot,
// the delivery log and the subscription table.
import { COMMON } from './common'
import { NAV } from './nav'
import { TERMS } from './terms'

export const EMAIL_ADMIN = {
  status: {
    sent: 'Gesendet',
    failed: 'Fehlgeschlagen',
    pending: 'Ausstehend',
    bounced: 'Zurückgewiesen',
  },
  tabs: {
    logs: TERMS.logs,
  },
  stats: {
    last24h: 'Letzte 24 Stunden',
  },
  robot: {
    never: 'Noch nie',
    interval: 'Intervall',
    minutes: 'Minuten',
    emailsSent: 'E-Mails gesendet',
    sendingDisabled: 'Der E-Mail-Versand ist global deaktiviert.',
  },
  logs: {
    recipient: 'Empfänger',
    subject: 'Betreff',
    template: COMMON.template,
    sentAt: 'Gesendet am',
    noLogs: 'Keine E-Mail-Protokolle vorhanden',
    search: 'E-Mail oder Betreff suchen',
  },
  subscriptions: {
    searchPlaceholder: 'Name oder E-Mail suchen …',
    user: NAV.users,
    unsubscribedAt: 'Abgemeldet am',
    resubscribeSuccess: 'Benutzer erfolgreich wieder angemeldet',
    unsubscribeSuccess: 'Benutzer erfolgreich abgemeldet',
    noSubscriptions: 'Keine Subscriptions vorhanden',
    total: COMMON.total,
  },
} as const
